// extracted by mini-css-extract-plugin
module.exports = {"successHeader":"SuccessModal_successHeader__1IPAc","successBody":"SuccessModal_successBody__3ijwB","successModalBtn":"SuccessModal_successModalBtn__24gKf"};